import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-border rounded-xl overflow-hidden" data-id="element-96">
      <button onClick={onToggle} className="w-full flex items-center justify-between gap-4 p-5 sm:p-6 text-left bg-surface hover:bg-surface/80 transition-colors duration-200" aria-expanded={isOpen} data-id="element-97">
        <span className="text-light text-base sm:text-lg font-semibold leading-snug pr-2" data-id="element-98">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} className="shrink-0" data-id="element-99">
          <ChevronDownIcon className="w-5 h-5 text-gold" data-id="element-100" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-101">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.35,
        ease: 'easeOut'
      }} className="overflow-hidden" data-id="element-102">
            <div className="px-5 sm:px-6 pb-5 sm:pb-6 pt-0" data-id="element-103">
              <p className="text-muted text-base leading-relaxed" data-id="element-104">{answer}</p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full py-16 md:py-24 px-4 sm:px-6 bg-carbon" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <motion.h2 className="text-gold text-3xl sm:text-4xl lg:text-5xl font-bold mb-10 md:mb-14 text-center leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-107">
          ¿Tienes preguntas? Las respondemos.
        </motion.h2>

        <motion.div className="space-y-3" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-108">
          <FAQItem question="¿Funciona si mi empresa es pequeña o recién empezando?" answer="Sí. De hecho, el sistema es más efectivo cuando se implementa desde el inicio. No necesitas una flota grande — necesitas un flujo constante de clientes de calidad." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-109" />
          <FAQItem question="¿Cuánto tiempo tarda en ver resultados?" answer="La mayoría de nuestros clientes ven las primeras mudanzas confirmadas en las primeras 2–3 semanas. El sistema completo alcanza velocidad de crucero en 60–90 días." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-110" />
          <FAQItem question="¿Qué pasa si ya tengo presencia en redes o Google?" answer="Perfecto. Construimos sobre lo que ya tienes. El sistema A.C.E.™ no reemplaza tu presencia actual — la potencia y la convierte en un motor de reservas." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-111" />
          <FAQItem question="¿Tienen contrato a largo plazo?" answer="No. Trabajamos mes a mes porque confiamos en los resultados. Si el sistema no funciona para ti, no tienes obligación de quedarte." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-112" />
          <FAQItem question="¿Qué diferencia a Doctor Ecommerce de otras agencias?" answer="Nos especializamos en el nicho de Moving. No somos una agencia genérica. Conocemos los ciclos de temporada, el problema de los No-Show, y cómo posicionar confianza en este mercado específico." isOpen={openIndex === 4} onToggle={() => handleToggle(4)} data-id="element-113" />
        </motion.div>
      </div>
    </section>;
}